module.exports = require('./angular.js').angular;
